import React from "react";

const WFIRSSQuestion7 = ({ questions, renderRadioInputs, questionKey }) => (
  <div key={`WFIRSSQuestion7${questionKey}`}>
    <div className="wfirs-progress-row">
      <div className="wfirs-progress-bar">
        <div style={{ width: "100%" }}></div>
      </div>
      <span className="wfirs-counter">7 / 7</span>
    </div>
    <h2 className="wfirs-section-title">Click the number for the rating that best describes how your emotional or behavioral problems have affected your Risky Activities.</h2>
    {questions.slice(55, 69).map((question, index) => (
      <div className="wfirs-question" key={index}>
        <label className="wfirs-q-label">{index + 56}. {question.questions}</label>
        {renderRadioInputs(index + 56)}
      </div>
    ))}
  </div>
);

export default WFIRSSQuestion7;
